import { render, staticRenderFns } from "./card-files.vue?vue&type=template&id=3340a609&"
import script from "./card-files.vue?vue&type=script&lang=js&"
export * from "./card-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports